import { t } from "i18next";

import {
  LOYALTY_CONFIRM_ICON,
  LOYALTY_MODAL_ICON,
  LoyaltyModal,
  LoyaltyModalFooter,
  LoyaltyModalIconHeader,
} from "./LoyaltyModal";

export { LOYALTY_CONFIRM_ICON, LOYALTY_MODAL_ICON };

function LoyaltyConfirmDialog({
  visible,
  iconType = LOYALTY_MODAL_ICON.QUESTION,
  message,
  onCancel,
  onConfirm,
  loading,
  confirmLabel,
}) {
  return (
    <LoyaltyModal
      visible={visible}
      onCancel={onCancel}
      width={520}
      title={<LoyaltyModalIconHeader iconType={iconType} />}
      className="loyalty-modal--icon-confirm"
      footer={
        <LoyaltyModalFooter
          onCancel={onCancel}
          onConfirm={onConfirm}
          loading={loading}
          confirmLabel={confirmLabel || t("common.confirm")}
        />
      }
    >
      <span className="loyalty-modal-icon-message">{message}</span>
    </LoyaltyModal>
  );
}

export default LoyaltyConfirmDialog;
